const cfg:Conifg = {
  baseUrl: `${window.location.origin}/api`,
  showIcp: true
}

export default cfg